import { Component, OnInit, ViewChild, WritableSignal, effect, computed, Signal, signal, inject, Injector, AfterViewInit } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MenuItem } from 'primeng/api';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ItemService } from '../../services/item-service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base-component';
import { CommandeService } from '../../services/commande-service';
import { Emplacement } from '../../entites/emplacement';
import { EmplacementService } from '../../services/emplacement-service';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { RapportService } from 'src/app/services/rapport-service';
import { SelectionItemComponent, ETypeSelectionItem, ResultatSelectionItem } from 'src/app/controles/selection-item.component';
import { ItemCommandeEntite } from 'src/app/entites/item-commande';
import { SignalWithWatcher } from 'src/app/services/base.service';
import { ReponseBase } from 'src/app/services/reponse-base';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { Statut } from 'src/app/entites/statut';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { SaisieQuantiteComponent } from 'src/app/controles/saisie-quantite.component';
import { ProfilService } from 'src/app/services/profil-service';
import { DatePipe } from '@angular/common';
import { InfoChangementStatut } from 'src/app/entites/info-changement-statut';
import { RequeteModifierItemCommande } from 'src/app/services/requetes/requete-modifier-item-commande';
import { AjustementInventaireComponent, ResultatAjustementInventaire } from 'src/app/controles/ajustement-inventaire.component';
import { AppMainComponent } from 'src/app/app.main.component';
import { SelectionTransporteurComponent } from 'src/app/controles/selection-transporteur.component';
import { RequisitionService } from 'src/app/services/requisition-service';
import { TransporteurEntite } from 'src/app/entites/transporteur';
import { ConsulterFournisseursComponent } from 'src/app/controles/consulter-fournisseurs.component';
import { PrixFournisseurEntite } from 'src/app/entites/prix-fournisseur';
import { CreationCommandeComponent, ResultatCreationBonCommande } from 'src/app/controles/creation-commande.component';
import { ContexteService } from 'src/app/services/contexte-service';
import { DepartementEntite } from 'src/app/entites/departement';
import { SelectionDepartementComponent } from 'src/app/controles/selection-departement.component';
import { CategorieEntite } from 'src/app/entites/categorie';
import { DefinitionColonne } from "src/app/entites/definition-colonne";
import { ActiviteService } from 'src/app/services/activite-service';
import { ETypeLien } from 'src/app/entites/enums/type-lien-document';
import { ActiviteEntite } from 'src/app/entites/activite';
import { AjoutRequisitionStepperComponent } from './ajout-requisition-stepper.component';
import { ConfirmationTransporteurComponent } from "src/app/controles/confirmation-transporteurs.component";
import { ConfirmationCreationRequisitionComponent } from "src/app/controles/confirmation-creation-requisitions.component";

@Component({
    templateUrl: './admin-commandes.component.html',
    styleUrls: ['./admin-commandes.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService, DatePipe],
    host: {
        '(document:keydown)': 'handleKeyboardEvents($event)'
    }
})
export class AdminCommandesComponent extends BaseComponent implements OnInit, AfterViewInit {

    emplacements: Emplacement[];
    tousLesEmplacements: Emplacement[];
    emplacement: WritableSignal<Emplacement[]> = signal<Emplacement[]>([]);
    emplacementSignal: WritableSignal<string[]> = this.createParamSignalList('emplacement', []);
    departements: DepartementEntite[];
    departement: WritableSignal<DepartementEntite[]> = signal<DepartementEntite[]>([]);
    departementSignal: WritableSignal<string[]> = this.createParamSignalList('departement', []);
    categories: CategorieEntite[];
    categorie: WritableSignal<CategorieEntite[]> = signal<CategorieEntite[]>([]);
    categorieSignal: WritableSignal<string[]> = this.createParamSignalList('categorie', []);
    statuts: Statut[] = this.sdb.StatutsCommande();
    statut: WritableSignal<Statut> = signal<Statut>(this.statuts[0]);
    statutSignal: WritableSignal<string> = this.createParamSignal('statut', this.statuts[0].nom);

    voirMesCommandes: WritableSignal<boolean> = signal<boolean>(false);


    itemsCommandeComplet: SignalWithWatcher<ItemCommandeEntite[]>;
    private itemsCommandeWatcherSignal = signal<SignalWithWatcher<ItemCommandeEntite[]> | undefined>(undefined);
    private injector = inject(Injector);
    itemsCommande: Signal<ItemCommandeEntite[]> = computed(() => {
        var items = this.itemsCommandeComplet.value();
        if (!items) {
            return [];
        }
        if (this.voirMesCommandes() && this.profilService.ProfilCourant()?.employeId) {
            return items.filter(x => x.departement?.employeId == this.profilService.ProfilCourant().employeId);
        }
        if (this.statut && this.statut().statutId != 0) {
            items = items.filter(x => x.statut.statutId == this.statut().statutId);
        }
        if (this.emplacement && this.emplacement().length > 0) {
            items = items.filter(x => this.emplacement().some(y => y.emplacementId == x.emplacement.emplacementId));
        }
        if (this.departement && this.departement().length > 0) {
            items = items.filter(x => this.departement().some(y => y.departementId == x.departement?.departementId));
        }
        if (this.categorie && this.categorie().length > 0) {
            items = items.filter(x => this.categorie().some(y => y.categorieId == x.item?.categorie?.categorieId));
        }
        return items;
    });
    selectionItemCommande: ItemCommandeEntite;
    selectionMultipleItemCommande: ItemCommandeEntite[] = [];
    menuContextuelEntrees: MenuItem[];

    // Dialog properties for popups
    afficherDialogueEmplacement: boolean = false;
    afficherDialogueCategorie: boolean = false;
    afficherDialogueDepartement: boolean = false;
    afficherDialogueCommandesActives: boolean = false;

    showStats: WritableSignal<boolean> = this.createLocalStorageSignal('showStats', false);

    nbItemsCommandePourUtilisateurCourant: Signal<number> = computed(() => {
        return this.itemsCommandeComplet.value().filter(x => x.departement?.employeId == this.profilService.ProfilCourant().employeId).length;
    });

    // Statistics for dashboard cards
    statsParStatut: Signal<{ statutNom: string, count: number }[]> = computed(() => {
        const items = this.itemsCommandeComplet.value();
        if (!items || items.length === 0) return [];

        const statsMap = new Map<string, number>();
        items.forEach(item => {
            const statusName = item.statut.nom || 'Unknown';
            statsMap.set(statusName, (statsMap.get(statusName) || 0) + 1);
        });

        return Array.from(statsMap.entries())
            .map(([statutNom, count]) => ({ statutNom, count }))
            .sort((a, b) => b.count - a.count)
            .slice(0, 4); // Limit to top 4 statuses to fit in card
    });

    nombreCommandesEnRetard: Signal<number> = computed(() => {
        const items = this.itemsCommandeComplet.value();
        if (!items) return 0;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return items.filter(item => {
            if (!item.dateRequis) return false;
            const dateRequis = new Date(item.dateRequis);
            dateRequis.setHours(0, 0, 0, 0);

            // Consider overdue if required date is past and status is not completed (assuming completed statuses have higher IDs)
            return dateRequis < today && ![9, 11, 10].includes(item.statut.statutId); // Adjust status IDs as needed
        }).length;
    });

    totalCommandesToutes: Signal<number> = computed(() => {
        return this.itemsCommandeComplet.value()?.length || 0;
    });

    // Signal for the last activity with TypeLien ItemCommande
    derniereActivite: WritableSignal<ActiviteEntite | null> = signal<ActiviteEntite | null>(null);

    // Signal to track when activity is being updated (for visual feedback)
    activiteEnCoursDeMAJ: WritableSignal<boolean> = signal<boolean>(false);

    // Track if this is the first time loading activity (to avoid showing update animation on initial load)
    private premiereChargementActivite: boolean = true;

    demandeurIdPrecedent?: number = null;

    /**
     * Maps statut names to their corresponding CSS class names
     */
    getStatutCssClass(statutNom: string): string {
        if (!statutNom) return '';

        // Convert the statut name to lowercase and remove accents/special characters for matching
        const normalizedStatut = statutNom.toLowerCase()
            .replace(/\s+/g, '');

        // Map the normalized names to CSS classes based on the statuts defined in styles.scss
        return normalizedStatut;
    }

    ref: DynamicDialogRef;

    menu: MenuItem[];
    menuContextuelActionsMultiplesItems: MenuItem[];

    panneauFiltreAffiche: boolean = false;

    colonnesSelectionneesSignal: WritableSignal<DefinitionColonne[]>;

    @ViewChild('dt') table: Table;
    @ViewChild('menuContextuelItemCommande') menuContextuelItemCommande: ContextMenu;
    @ViewChild('menuContextuelActionsMultiples') menuContextuelActionsMultiples: ContextMenu;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private CommandeService: CommandeService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public rapportService: RapportService,
        public routerService: Router,
        public datepipe: DatePipe,
        private activiteService: ActiviteService,
        private contexteService: ContexteService,
        private requisitionService: RequisitionService,
        private itemsService: ItemService) {

        super(sdb, profilService, route, routerService, appMain);

        this.colonnesDisponibles = [
            { champ: 'categorie', entete: 'Catégorie', afficheParDefaut: false },
            { champ: 'marque', entete: 'Marque', afficheParDefaut: this.userGotTheRight('SIHC_ContremaitreMecanique') },
            { champ: 'modele', entete: 'Modèle', afficheParDefaut: this.userGotTheRight('SIHC_ContremaitreMecanique') },
            { champ: 'demandeur', entete: 'Demandeur', afficheParDefaut: true },
            { champ: 'dateDemande', entete: 'Date de demande', afficheParDefaut: true },
            { champ: 'dateRequis', entete: 'Date requise', afficheParDefaut: true },
            { champ: 'expediteur', entete: 'Expéditeur', afficheParDefaut: true },
            { champ: 'camion', entete: 'Camion', afficheParDefaut: false },
            { champ: 'remorque', entete: 'Remorque', afficheParDefaut: false },
            { champ: 'chauffeur', entete: 'Chauffeur', afficheParDefaut: false },
            { champ: 'unite', entete: 'Unité', afficheParDefaut: false },
            { champ: 'codeProjet', entete: 'Code Projet', afficheParDefaut: false },
            { champ: 'codeActivite', entete: 'Code Activité', afficheParDefaut: false },
            { champ: 'codeCategorie', entete: 'Code Catégorie', afficheParDefaut: false },
            { champ: 'codeEquipement', entete: 'Code Équipement', afficheParDefaut: false },
            { champ: 'departement', entete: 'Département', afficheParDefaut: true },
            { champ: 'note', entete: 'Note', afficheParDefaut: true }
        ];
        this.colonnesSelectionneesSignal = this.createLocalStorageSignal('colonnesSelectionneesCommandesTous', this.colonnesDisponibles.filter(x => x.afficheParDefaut));
        this.breadcrumbService.setItems([
            { label: 'Admin commandes' }
        ]);
    }

    onFilterChange() {
        this.initialiserMenu();

        this.emplacementSignal.set(this.emplacement().map(x => x.nom));
        this.departementSignal.set(this.departement().map(x => x.nom));
        this.categorieSignal.set(this.categorie().map(x => x.nom));
        this.statutSignal.set(this.statut().nom);
    }

    initialiserFiltres() {
        this.emplacement.set(this.emplacements.filter(x => this.emplacementSignal().includes(x.nom)));
        this.departement.set(this.departements.filter(x => this.departementSignal().includes(x.nom)));
        this.categorie.set(this.categories.filter(x => this.categorieSignal().includes(x.nom)));
        this.statut.set(this.statuts.find(x => x.nom == this.statutSignal()));
    }

    handleKeyboardEvents(event: KeyboardEvent) {
        // if (event.key == '+' && !this.estFenetreAjoutItemActive) {
        //     this.surAjoutItem();
        // }
    }

    ngOnInit() {

        this.verifierAccesPage('commande_detail');

        this.DemarrerChargement();

        this.emplacements = this.sdb.EmplacementsComplet().filter(x => x.commandeActive);
        this.tousLesEmplacements = this.sdb.EmplacementsComplet();
        this.departements = this.sdb.Departements();

        this.categories = [...this.sdb.Categories()];
        this.categories.push({
            categorieId: 5,
            nom: 'Divers',
            description: 'Divers',
            estFacturable: false,
            estSuivi: false,
            estUnique: false,
            attributs: null
        });

        this.initialiserFiltres();

        // Setup effect to deselect items when they are deleted via backend updates (SignalR)
        effect(() => {
            const watcher = this.itemsCommandeWatcherSignal();
            if (!watcher?.updates?.()) return;
            const update = watcher.updates();
            if (update?.type === 'delete' && update?.data) {
                // For 'delete' events, data is the single removed element (SignalWithWatcher types it as T/array)
                const deletedId = (update.data as { itemCommandeId?: number }).itemCommandeId;
                if (deletedId == null) return;
                this.selectionMultipleItemCommande = this.selectionMultipleItemCommande.filter(
                    item => item.itemCommandeId !== deletedId
                );
                if (this.selectionItemCommande?.itemCommandeId === deletedId) {
                    this.selectionItemCommande = null;
                }
                this.surChangementSelection();
            }
        }, { injector: this.injector });

        this.CommandeService.ObtenirCommandeComplet((data: ItemCommandeEntite[]) => {
            data.forEach(ic => {
                if (ic.employe) {
                    ic.employe.prenomNom = ic.employe.prenom + ' ' + ic.employe.nom;
                }
                if (ic.demandeur) {
                    ic.demandeur.prenomNom = ic.demandeur.prenom + ' ' + ic.demandeur.nom;
                }
            });

            this.chargerDerniereActivite();

            return data;
        }).subscribe({
            next: (signalWatcher: SignalWithWatcher<ItemCommandeEntite[]>) => {
                this.itemsCommandeComplet = signalWatcher;
                this.itemsCommandeWatcherSignal.set(signalWatcher);

                this.CompleterChargement();
            },
            error: (error) => this.CompleterChargement()
        });

        this.initialiserMenu();
    }

    ngAfterViewInit() {
        this.chargerColonnesSelectionnees();
    }

    // Methods for Emplacement dialog
    ouvrirDialogueEmplacement() {
        this.afficherDialogueEmplacement = true;
    }

    fermerDialogueEmplacement() {
        this.afficherDialogueEmplacement = false;
    }

    // Methods for Departement dialog
    ouvrirDialogueDepartement() {
        this.afficherDialogueDepartement = true;
    }

    fermerDialogueDepartement(confirmer: boolean) {
        this.afficherDialogueDepartement = false;
    }

    // Methods for Catégorie dialog
    ouvrirDialogueCategorie() {
        this.afficherDialogueCategorie = true;
    }

    fermerDialogueCategorie(confirmer: boolean) {
        this.afficherDialogueCategorie = false;
    }

    // Methods for Commandes Actives dialog
    ouvrirDialogueCommandesActives() {
        this.afficherDialogueCommandesActives = true;
    }

    fermerDialogueCommandesActives() {
        this.afficherDialogueCommandesActives = false;
    }

    /// <summary>
    /// Sauvegarde les modifications des commandes actives
    /// </summary>
    sauvegarderCommandesActives() {
        this.Bloquer();

        this.CommandeService.ModifierCommandesActives(this.tousLesEmplacements).then(res => {
            if (res.estUnSucces) {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: 'Les commandes actives ont été mises à jour avec succès.'
                });

                // Mettre à jour la liste filtrée des emplacements actifs
                this.emplacements = this.tousLesEmplacements.filter(x => x.commandeActive);
                this.fermerDialogueCommandesActives();
            } else {
                res.messages.forEach(x => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: x.description
                    });
                });
            }
            this.Debloquer();
        }).catch(() => {
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Une erreur est survenue lors de la sauvegarde.'
            });
            this.Debloquer();
        });
    }

    userGotTheRight(right = '') {
        return this.profilService.Profil().roles.filter(x => x.nom == right).length > 0
    }

    // filtrer() {
    //     this.Bloquer();
    //        this.itemsCommande = this.itemsCommandeComplet;
    //        if (this.categorie && this.categorie.length > 0 ) {
    //             var ids = this.categorie.map(x => x.categorieId);
    //            this.itemsCommande = this.itemsCommande.filter(x => ids.includes(x.item?.categorie?.categorieId));
    //        }

    //     this.Debloquer();
    // }

    retirerFiltres() {
        this.emplacement.set([]);
        this.statut.set(this.statuts[0]);
        this.categorie.set([]);
        this.departement.set([]);
        this.voirMesCommandes.set(false);
    }

    initialiserMenu() {
        this.menu = [
            {
                label: 'Retour', icon: 'pi pi-fw pi-angle-double-left',
                command: () => window.history.back()
            },
            {
                label: 'Commandes',
                icon: 'pi pi-fw pi-eye',
                disabled: !this.estAutorise('approbation_precommande_detail') || this.emplacement().length != 1,
                command: () => this.routerService.navigateByUrl('commandes/' + this.emplacement()[0].emplacementId)
            },
            {
                label: 'Transport',
                icon: 'pi pi-fw pi-arrow-circle-up',
                disabled: !this.estAutorise('commande_statut_charge') || this.emplacement().length != 1,
                command: () => this.routerService.navigate(['transports'], {
                    queryParams: {
                        rows: 100,
                        multiSortMeta: JSON.stringify([
                            { field: 'date', order: -1 },
                            { field: 'numero', order: -1 }
                        ]),
                        filters: JSON.stringify({
                            'a.nom': [{
                                value: [this.emplacement()[0].nom],
                                matchMode: 'in',
                                operator: 'and'
                            }]
                        })
                    }
                })
            },
            {
                label: 'Réquisition',
                icon: 'pi pi-fw pi-plus',
                disabled: !this.estAutorise('requisition_creer') || this.emplacement().length != 1,
                items: [
                    {
                        label: 'Simple', icon: 'pi pi-fw pi-plus',
                        command: () => this.creerRequisition(event),
                        disabled: this.emplacement().length != 1
                    },
                    {
                        label: 'Selon transporteurs', icon: 'pi pi-fw pi-list',
                        command: () => this.creerRequisitionSelonTransporteurs(event),
                        disabled: this.emplacement().length != 1
                    }
                ]
            },
            {
                label: 'Commandes actives', icon: 'pi pi-fw pi-cog',
                visible: this.estAutorise('emplacement_modifier'),
                command: () => this.ouvrirDialogueCommandesActives()
            }
        ];
    }

    imprimer() {
        var emplacements = this.selectionMultipleItemCommande
            .map(x => x.emplacement)
            .filter((emp, index, arr) =>
                emp && emp.emplacementId !== undefined &&
                arr.findIndex(e => e && e.emplacementId === emp.emplacementId) === index
            );

        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée pour ${emplacements.length} emplacements` });

        for (const emplacement of emplacements) {
            this.rapportService.ProduireRapportCommande({
                emplacementId: emplacement.emplacementId,
                itemIds: this.selectionMultipleItemCommande.filter(x => x.emplacement.emplacementId == emplacement.emplacementId).map(x => x.itemCommandeId)
            }).then(x => {
                if (x) {
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
                } else {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
                }
            });
        }
    }

    creerRequisition(event: Event) {

        this.contexteService.Ajouter('commande.emplacementId', this.emplacement()[0].emplacementId.toString());

        this.routerService.navigateByUrl('requisition/nouveau');

    }

    creerRequisitionSelonTransporteurs(event: Event) {
        const ref = this.dialogService.open(ConfirmationTransporteurComponent, {
            data: {
                emplacementId: this.emplacement()[0].emplacementId
            },
            header: 'Confirmer réquisition(s)',
            width: '50%'
        }).onClose.subscribe((res: TransporteurEntite[]) => {
            if (res) {
                this.Bloquer();
                this.requisitionService.CreerSelonTransporteurs({
                    emplacementId: this.emplacement()[0].emplacementId,
                    transporteurs: res
                }).then(resCreation => {
                    if (resCreation.estUnSucces) {

                        const ref = this.dialogService.open(ConfirmationCreationRequisitionComponent, {
                            data: {
                                requisitionIds: resCreation.valeur
                            },
                            header: 'Réquisitions créées',
                            width: '50%'
                        });

                        this.Debloquer();
                    } else {
                        this.Debloquer();
                        resCreation.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                        });
                    }
                })
            }
        });
    }

    estFenetreAjoutItemActive: boolean = false;
    surAjoutItem() {

        if (this.emplacement().length != 1) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Veuillez sélectionner un seul emplacement.' });
            this.afficherDialogueEmplacement = true;
            return;
        }

        this.estFenetreAjoutItemActive = true;
        const ref = this.dialogService.open(SelectionItemComponent, {
            data: {
                type: ETypeSelectionItem.Commande,
                demandeurId: this.demandeurIdPrecedent,
                emplacementIdVerificationTransfertExpress: 10000
            },
            header: 'Sélection d\'un item',
            width: '95%'
        }).onClose.subscribe((res: ResultatSelectionItem) => {
            this.estFenetreAjoutItemActive = false;
            if (res) {
                var itemCommande: ItemCommandeEntite = {
                    itemCommandeId: 0,
                    emplacement: { ...this.emplacement()[0] },
                    item: res.item,
                    statut: this.sdb.Statut(EStatuts.EnAttente),
                    employe: this.profilService.ProfilCourant(),
                    dateDemande: res.dateDemande,
                    dateRequis: res.dateRequis,
                    quantiteDemande: res.quantiteDemande,
                    quantite: res.quantiteDemande,
                    expediteur: res.expediteur,
                    demandeur: res.demandeur,
                    unite: res.unite,
                    indPrecommande: false
                }

                this.CommandeService.CreerItemCommande({
                    itemCommande: itemCommande,
                    cout: res.cout
                }).then(resCreation => {
                    if (resCreation.estUnSucces) {

                        itemCommande.itemCommandeId = resCreation.valeur.itemCommande.itemCommandeId;

                        var itemExistant = this.itemsCommande().find(x => x.itemCommandeId == itemCommande.itemCommandeId);

                        if (itemExistant) {

                            itemExistant.quantite = resCreation.valeur.itemCommande.quantite;
                            itemExistant.quantiteDemande = resCreation.valeur.itemCommande.quantiteDemande;

                            var itemsAAJuster = this.itemsCommande().filter(x => x.item.itemId == resCreation.valeur.itemCommande.item.itemId &&
                                x.demandeur.employeId == resCreation.valeur.itemCommande.demandeur.employeId);

                            itemsAAJuster.forEach(x => {
                                x.quantiteDemande = resCreation.valeur.itemCommande.quantiteDemande;
                            });

                        } else {

                            this.itemsCommandeComplet.value.set([...this.itemsCommandeComplet.value(), itemCommande]);

                        }

                        this.updateVisibility();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: `L'item '${itemCommande.item.description} (${itemCommande.item.numero})' a été ajouté.` });
                        resCreation.messages?.forEach(x => {
                            if (x.severity === 'warn' || x.type === 1) {
                                this.messageService.add({ severity: 'warn', summary: 'Avertissement', detail: x.description });
                            }
                        });

                    } else {
                        resCreation.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

                this.demandeurIdPrecedent = res.demandeur?.employeId;
            }


        });

    }

    surChangementSelection() {
        this.initialiserMenu();
        //this.menu[this.menu.length - 1].items.forEach(x => x.disabled = this.selectionMultipleItemCommande.length == 0);
    }

    menuVisible: boolean = true;
    rafraichirMenu() {
        this.menuVisible = false;
        setTimeout(() => this.menuVisible = true, 0);
    }

    visible: boolean = true;
    updateVisibility(): void {
        this.visible = false;
        setTimeout(() => this.visible = true, 0);
    }

    supprimerItems(items: ItemCommandeEntite[]) {
        var ids = items.map(b => b.itemCommandeId);
        this.confirmationService.confirm({
            message: items.length == 1 ? 'Voulez-vous vraiment supprimer l\'item sélectionné ?' : 'Voulez-vous vraiment supprimer les items sélectionnés ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.CommandeService.SupprimerItemsCommande(ids).then(res => {
                    if (res.estUnSucces) {
                        this.itemsCommandeComplet.value.set(this.itemsCommandeComplet.value().filter((ic: ItemCommandeEntite) => !ids.includes(ic.itemCommandeId)));
                        // Deselect deleted items from selection
                        this.selectionMultipleItemCommande = this.selectionMultipleItemCommande.filter(item => !ids.includes(item.itemCommandeId));
                        if (this.selectionItemCommande && ids.includes(this.selectionItemCommande.itemCommandeId)) {
                            this.selectionItemCommande = null;
                        }
                        this.surChangementSelection();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Items supprimés.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    surMenuContextuelItem(event, itemCommande: ItemCommandeEntite) {
        this.selectionItemCommande = itemCommande;

        this.menuContextuelEntrees = [
            {
                label: 'Voir l\'item', icon: 'pi pi-fw pi-search',
                visible: this.estAutorise('item_detail'),
                command: () => this.routerService.navigateByUrl(`item/${itemCommande.item.itemId}`),
                items: this.itemsService.getItemActions(itemCommande.item)
            },
            {
                label: 'Changer la quantité', icon: 'pi pi-fw pi-sort',
                visible: this.estAutorise('commande_modifier_item'),
                command: () => this.modifierQuantite(itemCommande)
            },
            { separator: true, visible: this.estAutorise('commande_statut_enattente') || this.estAutorise('commande_statut_pret') },
            {
                label: 'En attente', icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('commande_statut_enattente') && itemCommande.statut.statutId != 5,
                command: () => this.changerStatut(itemCommande, itemCommande.quantite, 5, false)
            },
            {
                label: 'En attente (partiel)', icon: 'pi pi-fw pi-caret-right',
                visible: this.estAutorise('commande_statut_enattente') && itemCommande.statut.statutId != 5,
                disabled: itemCommande.quantite == 1,
                command: () => this.changerStatut(itemCommande, itemCommande.quantite, 5, true)
            },
            {
                label: 'À commander', icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('commande_statut_enattente') && itemCommande.statut.statutId != 28,
                command: () => this.changerStatut(itemCommande, itemCommande.quantite, 28, false)
            },
            {
                label: 'À commander (partiel)', icon: 'pi pi-fw pi-caret-right',
                visible: this.estAutorise('commande_statut_enattente') && itemCommande.statut.statutId != 28,
                disabled: itemCommande.quantite == 1,
                command: () => this.changerStatut(itemCommande, itemCommande.quantite, 28, true)
            },
            {
                label: 'Prêt', icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('commande_statut_pret') && (itemCommande.statut.statutId != 9),
                command: () => this.changerStatut(itemCommande, itemCommande.quantite, 9, false)
            },
            {
                label: 'Prêt (partiel)', icon: 'pi pi-fw pi-caret-right',
                visible: this.estAutorise('commande_statut_pret') && (itemCommande.statut.statutId != 9),
                disabled: itemCommande.quantite == 1,
                command: () => this.changerStatut(itemCommande, itemCommande.quantite, 9, true)
            },
            {
                label: 'Chargé', icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('commande_statut_charge') && itemCommande.statut.statutId != 11,
                command: () => this.changerStatut(itemCommande, itemCommande.quantite, 11, false)
            },
            {
                label: 'Chargé (partiel)', icon: 'pi pi-fw pi-caret-right',
                visible: this.estAutorise('commande_statut_charge') && itemCommande.statut.statutId != 11,
                disabled: itemCommande.quantite == 1,
                command: () => this.changerStatut(itemCommande, itemCommande.quantite, 11, true)
            },
            { separator: true, visible: this.estAutorise('bdc_creer') || this.estAutorise('requisition_creer') },
            {
                label: 'Commander', icon: 'pi pi-fw pi-shopping-cart',
                visible: this.estAutorise('bdc_creer'),
                disabled: !itemCommande.item.categorie.estSuivi,
                command: () => this.commander(itemCommande)
            },
            {
                label: 'Ajouter à une réquisition', icon: 'pi pi-fw pi-truck',
                visible: this.estAutorise('requisition_creer'),
                command: () => this.ajouterARequisitionSingle(itemCommande)
            },
            { separator: true, visible: this.estAutorise('commande_modifier_item') },
            {
                label: 'Assigner',
                icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('commande_modifier_item'),
                command: x => this.assigner(itemCommande)
            }
        ];


        this.menuContextuelItemCommande.toggle(event);
        setTimeout(() => {
            (this.menuContextuelItemCommande as any).dirty = true;
        }, 0);
    }

    modifierQuantite(itemCommande: ItemCommandeEntite) {
        const ref = this.dialogService.open(SaisieQuantiteComponent, {
            data: {
                quantite: itemCommande.quantiteDemande,
                min: 1
            },
            header: 'Saisir la quantité',
            width: '50%'
        }).onClose.subscribe((res: number) => {
            if (res) {
                this.CommandeService.ModifierqteItemCommande({
                    employe: this.profilService.ProfilCourant(),
                    emplacement: itemCommande.emplacement,
                    itemsCommande: [{
                        itemCommandeId: itemCommande.itemCommandeId,
                        quantite: res
                    }]
                }).then(res => {
                    if (res.estUnSucces) {

                        res.valeur.itemCommandeModifies.forEach(x => {
                            var itemCommandeAModifier = this.itemsCommande().find(ic => ic.itemCommandeId == x.itemCommandeId);
                            itemCommandeAModifier.quantiteDemande = x.quantiteDemande;
                            itemCommandeAModifier.quantite = x.quantite;
                        });

                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Statut modifié` });

                        this.initialiserMenu();

                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                }).catch(() => {
                    this.routerService.navigateByUrl('error');
                });
            }

        });
    }

    changerStatut(itemCommande: ItemCommandeEntite, quantite: number, statutId: number, partiel: boolean) {
        if (partiel) {

            const ref = this.dialogService.open(SaisieQuantiteComponent, {
                data: {
                    quantite: quantite,
                    min: 1,
                    max: quantite
                },
                header: 'Saisir la quantité',
                width: '50%'
            }).onClose.subscribe((res: number) => {
                if (res) {
                    this.confirmerChangerStatut(itemCommande.emplacement.emplacementId, [{
                        itemCommandeId: itemCommande.itemCommandeId,
                        quantite: res,
                        statutId: statutId,
                        indPrecommande: false
                    }]);
                }

            });

        } else {
            this.confirmerChangerStatut(itemCommande.emplacement.emplacementId, [{
                itemCommandeId: itemCommande.itemCommandeId,
                quantite: quantite,
                statutId: statutId,
                indPrecommande: false
            }]);
        }
    }

    changerStatutLot(statutId: number) {
        if (this.selectionMultipleItemCommande.length > 0) {
            var infos: InfoChangementStatut[] = [];

            this.selectionMultipleItemCommande.forEach(ic => {
                infos.push({
                    itemCommandeId: ic.itemCommandeId,
                    quantite: ic.quantite,
                    statutId: statutId,
                    indPrecommande: false
                });
            });

            this.confirmerChangerStatut(this.selectionMultipleItemCommande[0].emplacement.emplacementId, infos);
        }
    }

    confirmerChangerStatut(emplacementId: number, info: InfoChangementStatut[]) {

        var p1 = new Promise<TransporteurEntite>((resolve, reject) => {
            if (info[0].statutId == EStatuts.Charge) {
                const ref = this.dialogService.open(SelectionTransporteurComponent, {
                    data: {
                        emplacementId: emplacementId
                    },
                    header: 'Sélectionner le transporteur',
                    width: '50%'
                }).onClose.subscribe((res: TransporteurEntite) => {
                    if (res) {
                        resolve(res);
                    } else {
                        reject();
                    }
                });
            } else {
                resolve(null);
            }
        });

        p1.then(r => {
            var requete: RequeteModifierItemCommande = {
                employe: this.profilService.ProfilCourant(),
                emplacement: this.sdb.Emplacement(emplacementId),
                itemsCommande: []
            };

            info.forEach(x => {
                requete.itemsCommande.push({
                    itemCommandeId: x.itemCommandeId,
                    quantite: x.quantite,
                    statutId: x.statutId,
                    camion: r?.camion,
                    remorque: r?.remorque,
                    chauffeur: r?.chauffeur,
                    indPrecommande: false
                });
            });
            this.messageService.add({ severity: 'info', summary: 'Info', detail: `Modification en cours...` });
            this.CommandeService.ModifierItemCommande(requete).then(res => {
                if (res.estUnSucces) {

                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Statut modifié` });

                    this.initialiserMenu();

                } else {
                    res.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                    });
                }
            }).catch(() => {
                this.routerService.navigateByUrl('error');
            });
        }, r => { });

    }

    assigner(item: ItemCommandeEntite) {

        const ref = this.dialogService.open(SelectionDepartementComponent, {
            header: 'Sélectionner un département',
            width: '50%'
        }).onClose.subscribe((resSelectionDepartement: DepartementEntite) => {
            if (resSelectionDepartement) {
                this.CommandeService.ModifierAssignationItemCommande({
                    employe: this.profilService.ProfilCourant(),
                    emplacement: item.emplacement,
                    itemsCommande: [{
                        itemCommandeId: item.itemCommandeId,
                        quantite: item.quantite,
                        statutId: item.statut.statutId,
                        transporteur: item.transporteur,
                        camion: item.camion,
                        remorque: item.remorque,
                        chauffeur: item.chauffeur,
                        departementId: resSelectionDepartement.departementId,
                        indPrecommande: item.indPrecommande
                    }]
                }).then(res => {
                    if (res.estUnSucces) {

                        item.departement = this.sdb.Departement(resSelectionDepartement.departementId);

                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Item réassigné` });

                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                }).catch(() => {
                    this.routerService.navigateByUrl('error');
                });
            }
        });
    }

    commander(item: ItemCommandeEntite) {

        const ref = this.dialogService.open(ConsulterFournisseursComponent, {
            data: {
                itemId: item.item.itemId,
                afficherSelection: true,
                afficherCommander: false
            },
            header: 'Sélectionner un fournisseur',
            width: '50%'
        }).onClose.subscribe((res: PrixFournisseurEntite) => {
            if (res) {

                var codeProjetId = item.codeProjet ? item.codeProjet.codeProjetId : item.emplacement.codeProjet?.codeProjetId;

                const ref2 = this.dialogService.open(CreationCommandeComponent, {
                    data: {
                        itemId: item.item.itemId,
                        numeroItem: item.item.numero,
                        descriptionItem: item.item.description,
                        fournisseurId: res.fournisseur.fournisseurId,
                        nomFournisseur: res.fournisseur.nom,
                        numeroFournisseur: res.fournisseur.numero,
                        numeroItemFournisseur: res.numeroFournisseur,
                        prix: res.prix,
                        selectionCodeProjet: codeProjetId,
                        selectionCodeActivite: item.codeActivite?.codeActiviteId

                    },
                    header: 'Création d\'un bon de commande',
                    width: '60%'
                }).onClose.subscribe((res2: ResultatCreationBonCommande) => {
                    if (res2) {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été ajouté au bon de commande.' });
                        /* if (res2.redirection) {
                            this.routerService.navigateByUrl('achat/' + res2.bonCommandeId);
                        } else {
                            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été ajouté au bon de commande.' });
                        } */
                    }
                });
            }
        });
    }

    ajustementInventaire(itemCommande: ItemCommandeEntite) {
        const ref = this.dialogService.open(AjustementInventaireComponent, {
            data: {
                itemId: itemCommande.item.itemId,
                emplacementId: 10000, // TODO: Gérer le multi entrepot.
                numero: itemCommande.item.numero,
                description: itemCommande.item.description,
                emplacement: `TODO`,
                quantiteCourante: itemCommande.item.quantite
            },
            header: 'Ajustement d\'inventaire',
            width: '50%'
        }).onClose.subscribe((res: ResultatAjustementInventaire) => {
            if (res) {
                itemCommande.item.quantite = res.nouvelleQuantite;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `L'inventaire de l'item '${itemCommande.item.description} (${itemCommande.item.numero})' a été ajusté.` });
            }
        });
    }

    /**
     * Loads the most recent activity with TypeLien ItemCommande
     */
    private chargerDerniereActivite(): void {
        // Only show visual feedback if this is NOT the first time loading (i.e., it's an actual update)
        if (!this.premiereChargementActivite) {
            this.activiteEnCoursDeMAJ.set(true);
        }

        this.activiteService.ObtenirParType(ETypeLien.ItemCommande).subscribe({
            next: (response: ReponseBase<ActiviteEntite[]>) => {
                if (response.estUnSucces && response.valeur && response.valeur.length > 0) {
                    // Get the most recent activity (assuming they are ordered by date desc)
                    const derniereActivite = response.valeur[0];
                    this.derniereActivite.set(derniereActivite);
                } else {
                    this.derniereActivite.set(null);
                }

                // Mark that the first load is complete
                if (this.premiereChargementActivite) {
                    this.premiereChargementActivite = false;
                } else {
                    // Only show the visual effect if it was an actual update (not first load)
                    setTimeout(() => {
                        this.activiteEnCoursDeMAJ.set(false);
                    }, 1500); // Show the effect for 1.5 seconds
                }
            },
            error: (error) => {
                console.error('Erreur lors du chargement de la dernière activité:', error);
                this.derniereActivite.set(null);

                // Mark that the first load is complete even on error
                if (this.premiereChargementActivite) {
                    this.premiereChargementActivite = false;
                } else {
                    // Remove the visual indicator even on error (only if it was shown)
                    setTimeout(() => {
                        this.activiteEnCoursDeMAJ.set(false);
                    }, 1500);
                }
            }
        });
    }

    surActionsMultiples(event: Event) {
        const actions = [
            {
                label: 'En attente',
                icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('commande_statut_enattente'),
                command: () => this.changerStatutLot(5),
                disabled: this.selectionMultipleItemCommande.length == 0 || this.selectionMultipleItemCommande.filter(x => x.statut.statutId == 5).length != 0
            },
            {
                label: 'À commander',
                icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('commande_statut_enattente'),
                command: () => this.changerStatutLot(28),
                disabled: this.selectionMultipleItemCommande.length == 0 || this.selectionMultipleItemCommande.filter(x => x.statut.statutId == 28).length != 0
            },
            {
                label: 'Prêt',
                icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('commande_statut_pret'),
                command: () => this.changerStatutLot(9),
                disabled: this.selectionMultipleItemCommande.length == 0 || this.selectionMultipleItemCommande.filter(x => x.statut.statutId == 9).length != 0
            },
            {
                label: 'Chargé',
                icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('commande_statut_charge'),
                command: () => this.changerStatutLot(11),
                disabled: this.selectionMultipleItemCommande.length == 0 || this.selectionMultipleItemCommande.filter(x => x.statut.statutId == 11).length != 0
            },
            {
                separator: true, visible: this.estAutorise('requisition_creer')
            },
            {
                label: 'Imprimer', icon: 'pi pi-fw pi-print', command: () => this.imprimer(),
                disabled: this.selectionMultipleItemCommande.length == 0
            },
            {
                label: 'Ajouter à un transport',
                icon: 'pi pi-fw pi-truck',
                visible: this.estAutorise('requisition_creer'),
                command: () => this.ajouterARequisition(),
                disabled: this.selectionMultipleItemCommande.length == 0
            },
            {
                separator: true, visible: this.estAutorise('commande_supprimer_item')
            },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-times',
                visible: this.estAutorise('commande_supprimer_item'),
                command: () => this.supprimerItems(this.selectionMultipleItemCommande),
                disabled: this.selectionMultipleItemCommande.length == 0
            },
        ];

        this.menuContextuelActionsMultiplesItems = actions;
        this.menuContextuelActionsMultiples.show(event);
    }

    ajouterARequisition() {
        let self = this;

        const ref = this.dialogService.open(AjoutRequisitionStepperComponent, {
            header: 'Ajouter à une réquisition',
            width: '90vw',
            height: '80vh',
            maximizable: true,
            data: {
                items: this.selectionMultipleItemCommande
            }
        });

        setTimeout(() => {
            const dialogInstance = self.dialogService.getInstance(ref);
            if (dialogInstance) {
                dialogInstance.maximize();
            }
        }, 0);

        ref.onClose.subscribe((result) => {
            if (result && result.success) {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: `${result.results.filter(r => r.success).length} groupe(s) traité(s) avec succès`
                });

                // Clear selection
                this.selectionMultipleItemCommande = [];
            }
        });
    }

    ajouterARequisitionSingle(itemCommande: ItemCommandeEntite) {
        let self = this;
        const ref = this.dialogService.open(AjoutRequisitionStepperComponent, {
            header: 'Ajouter à une réquisition',
            width: '90vw',
            height: '80vh',
            maximizable: true,
            data: {
                items: [itemCommande]
            }
        });

        setTimeout(() => {
            const dialogInstance = self.dialogService.getInstance(ref!);
            if (dialogInstance) {
                dialogInstance.maximize();
            }
        }, 0);

        ref.onClose.subscribe((result) => {
            if (result && result.success) {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: 'Item ajouté à la réquisition avec succès'
                });
            }
        });
    }

    /**
     * Gets the total column count for the table colspan in group headers
     */
    getTableColspan(): number {
        // Base columns: checkbox + emplacement + quantité + statut + numéro + description + actions
        let baseColumns = 7;

        // Add conditional columns
        const conditionalColumns = [
            'categorie', 'marque', 'modele', 'demandeur', 'dateDemande',
            'dateRequis', 'expediteur', 'camion', 'remorque', 'chauffeur',
            'unite', 'codeProjet', 'codeActivite', 'codeCategorie',
            'departement', 'note'
        ];

        baseColumns += conditionalColumns.filter(col =>
            this.EstColonneSelectionneeSignal(col, this.colonnesSelectionneesSignal)
        ).length;

        return baseColumns;
    }

    /**
     * Gets the count of items for a specific emplacement
     */
    getEmplacementItemCount(emplacementNom: string): number {
        return this.itemsCommande().filter(item =>
            item.emplacement.nom === emplacementNom
        ).length;
    }

    /**
     * Filters the table to show only items from a specific emplacement
     */
    filtrerParEmplacement(emplacement: Emplacement): void {
        // Clear existing emplacement filter and set to specific emplacement
        this.emplacement.set([this.emplacements.find(e => e.emplacementId === emplacement.emplacementId)]);

        this.onFilterChange();

        // Show success message
        this.messageService.add({
            severity: 'info',
            summary: 'Filtre appliqué',
            detail: `Affichage des items pour l'emplacement: ${emplacement.nom}`
        });
    }

    supprimerFiltreEmplacement(emplacement: Emplacement): void {
        this.emplacement.set(this.emplacement().filter(e => e.emplacementId !== emplacement.emplacementId));
        this.onFilterChange();
    }

    filterIsSet(emplacement: Emplacement): boolean {
        return this.emplacement().some(e => e.emplacementId === emplacement.emplacementId);
    }

    /**
     * Checks if all items in an emplacement group are selected
     */
    isEmplacementGroupSelected(emplacementNom: string): boolean {
        const itemsInGroup = this.itemsCommande().filter(
            item => item.emplacement.nom === emplacementNom
        );

        if (itemsInGroup.length === 0) {
            return false;
        }

        return itemsInGroup.every(item =>
            this.selectionMultipleItemCommande.includes(item)
        );
    }

    /**
     * Toggles selection for all items in an emplacement group
     */
    toggleEmplacementGroupSelection(emplacementNom: string, checked: boolean): void {
        const itemsInGroup = this.itemsCommande().filter(
            item => item.emplacement.nom === emplacementNom
        );

        if (checked) {
            // Add all items from this group that are not already selected
            itemsInGroup.forEach(item => {
                if (!this.selectionMultipleItemCommande.includes(item)) {
                    this.selectionMultipleItemCommande.push(item);
                }
            });
        } else {
            // Remove all items from this group from selection
            this.selectionMultipleItemCommande = this.selectionMultipleItemCommande.filter(
                selectedItem => !itemsInGroup.includes(selectedItem)
            );
        }

        // Create a new array reference to trigger change detection in PrimeNG table
        this.selectionMultipleItemCommande = [...this.selectionMultipleItemCommande];

        // Trigger change detection for the selection
        this.surChangementSelection();
    }

    /**
     * Gets unique emplacements from currently selected rows
     */
    getUniqueEmplacementsFromSelection(): Emplacement[] {
        if (!this.selectionMultipleItemCommande || this.selectionMultipleItemCommande.length === 0) {
            return [];
        }

        const uniqueEmplacements = new Map<number, Emplacement>();

        this.selectionMultipleItemCommande.forEach(item => {
            if (item.emplacement && item.emplacement.emplacementId) {
                uniqueEmplacements.set(item.emplacement.emplacementId, item.emplacement);
            }
        });

        return Array.from(uniqueEmplacements.values());
    }

    getStatutCountForEmplacement(emplacement: Emplacement, statut: Statut): number {
        if (!this.chargementComplete) {
            return 0;
        }
        return this.itemsCommande().filter(item => item.emplacement.emplacementId === emplacement.emplacementId && item.statut.statutId === statut.statutId).length;
    }

    isDateRequisExpired(dateRequis: Date): boolean {
        return dateRequis && dateRequis < new Date();
    }

    hasMultipleLines(description: string): boolean {
        return this.itemsCommande().filter(item => item.item.description === description && item.quantite != item.quantiteDemande).length > 1;
    }

    /**
     * Generates a consistent color based on the item numero using a simple hash function.
     * The color is seeded from the numero string so the same item always gets the same color.
     * @param numero The item numero to generate a color for
     * @returns HSL color string
     */
    getCouleurPourNumero(description: string): string {
        if (!description) return 'transparent';

        // Simple hash function to generate a number from string
        let hash = 0;
        for (let i = 0; i < description.length; i++) {
            const char = description.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32bit integer
        }

        // Use the hash to generate HSL color with good saturation and lightness
        const hue = Math.abs(hash) % 360;
        const saturation = 65 + (Math.abs(hash >> 8) % 20); // 65-85%
        const lightness = 45 + (Math.abs(hash >> 16) % 15); // 45-60%

        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }
}
